import { useCallback, useEffect, useState } from "react";
import { useLatestRequest } from "../../../hooks/useLatestRequest";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { qrScannerApi, type ScannerEvent } from "../qrScanner.api";

export const useScannerTodayEvents = () => {
  const [events, setEvents] = useState<ScannerEvent[]>([]);
  const [error, setError] = useState<string | null>(null);
  const { run, loading } = useLatestRequest();

  const refetch = useCallback(async () => {
    setError(null);
    try {
      const result = await run((signal) => qrScannerApi.getTodayEvents(signal));
      if (result !== undefined) setEvents(result);
    } catch (requestError: unknown) {
      setError(getApiErrorMessage(requestError, "Failed to load events"));
    }
  }, [run]);

  useEffect(() => {
    void refetch();
  }, [refetch]);

  return { events, error, isLoading: loading, refetch };
};
